export const apiRoutes = {
  downloadSMBUsersList: () => `/smb-users/export`,
};
